/** Values stored in `IPrivateUserData.permissions` — keys must match `provisionPermissionsByRoles`. */

export const ORDER_MANAGER_PERMISSION = "ordermanager";
export const PRICE_CALCULATOR_PERMISSION = "pricecalculator";
export const DESIGNER_ENGINEER_PERMISSION = "designer";
export const SUNLAB_IMPORT_TEMPLATES_PERMISSION = "sunlabimporttemplates";
export const USER_MANAGER_PERMISSION = "usermanager";
export const INSTRUMENT_MANAGER_PERMISSION = "instrumentmanager";
